import { StyledLabel, StyledOptionalFieldWrap } from "./style";
import type { OptionalFields } from "../../Sections/ActionSection";
import { Icon } from "@smartsuite/react-ui/lib";
import { useState } from "react";
import type {
  InputDescription,
  IntegrationDescription,
} from "@smartsuite/automation-engine-api";
import type {
  ActionCandidate,
  InputCandidate,
  TriggerCandidate,
} from "../../../../types/candidate";
import { InputForm } from "../InputForm";
import { isValueExist } from "../../../../services/isValueExist";
import { translateIfPresent } from "../../../../locales/i18n";
import { GrayColors } from "@smartsuite/types";

export const OptionalForm: React.FC<{
  optionalFields: OptionalFields;
  descriptions: InputDescription[];
  trigger: TriggerCandidate;
  actions: ActionCandidate[];
  actionHash: string;
  /** Forwarded to InputForm -- see its `currentAction` note (BUG-21280). */
  currentAction?: ActionCandidate;
  integrations: IntegrationDescription[];
  loading?: boolean;
  onChange: (input: InputCandidate) => void;
  showValidationError?: boolean;
}> = ({
  optionalFields,
  descriptions,
  trigger,
  actions,
  actionHash,
  currentAction,
  integrations,
  loading,
  onChange,
  showValidationError,
}) => {
  const hasData =
    optionalFields.inputs.filter((input) => isValueExist(input)).length > 0;

  const [opened, setOpened] = useState(hasData);

  return (
    <>
      <StyledLabel
        onClick={() => {
          setOpened(!opened);
        }}
      >
        {opened
          ? translateIfPresent(
              `general.${optionalFields.elapsedLabel}`,
              optionalFields.elapsedLabel,
            )
          : translateIfPresent(
              `general.${optionalFields.label}`,
              optionalFields.label,
            )}
        <Icon
          name={opened ? "arrow-up-small" : "arrow-down-small"}
          color={GrayColors["G-4"]}
          size={"S"}
          dimension={{ width: 14, height: 14 }}
        />
      </StyledLabel>
      {opened &&
        optionalFields.inputs.map((input) => (
          <StyledOptionalFieldWrap key={`${actionHash}-${input.inputId}`}>
            <InputForm
              loading={loading}
              key={`${actionHash}-${input.inputId}`}
              input={input}
              descriptions={descriptions}
              trigger={trigger}
              actions={actions}
              actionHash={actionHash}
              currentAction={currentAction}
              integrations={integrations}
              showValidationError={showValidationError}
              onChange={(input) => {
                onChange(input);
              }}
            />
          </StyledOptionalFieldWrap>
        ))}
    </>
  );
};
